import React from 'react';
import cn from 'classnames';
import { useDesksConfigsParams } from '../../services/desksConfigs';
import { useExistingDesksSettingsQueries } from '../../../../services/queries/deskSettingsData';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import styles from './index.module.scss';

const FetchInitDataWrapper = ({ children, className }) => {
  const params = useDesksConfigsParams();

  const { data, isFetching, refetch } = useExistingDesksSettingsQueries(params);

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить настройки для приемки"
      className={cn(styles.root, className)}
    >
      {children}
    </FetchDataWrapper>
  );
};

export default FetchInitDataWrapper;
